import React from "react";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Priya R",
    text: "I sold my old gold jewelry at Sell Gold Company and got a great price. The staff was friendly and professional. Highly recommended!",
  },
  {
    name: "Rajesh M",
    text: "I needed quick cash and Sell Gold Company provided a fair price for my gold. The process was smooth and efficient.",
  },
  {
    name: "Sneha K",
    text: "Sell Gold Company is trustworthy and offers the best rates. The staff explained everything clearly and I received my cash immediately.",
  },
  {
    name: "Anil T",
    text: "Fantastic experience. They evaluated my gold in front of me and offered a very competitive price.",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials">
      <div className="header">
        <h2>Testimonials</h2>
        <p>Real experiences from our happy customers</p>
      </div>

      <div className="grid">
        {testimonials.map((item, index) => (
          <div className="card" key={index}>
            <div className="quote">“</div>

            <p className="text">{item.text}</p>

            <div className="user">
              <div className="avatar">
                {item.name.charAt(0)}
              </div>
              <div>
                <h4>{item.name}</h4>
                <span>Verified Customer</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;